import { useContext } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { AdminContext, ClientContext } from "../App";
import ButtonPrimary from "../components/ButtonPrimary";
import TeamTable from "../components/TeamTable";
import Add from "../icons/Add";
import { CLIENT_ID_PARAM } from "../lib/constants";

const AddTeamMember = () => {
  const [searchParams] = useSearchParams();
  const { selectedClient } = useContext(ClientContext);

  // Get client ID from URL params if available, otherwise use context
  const clientId = searchParams.get(CLIENT_ID_PARAM) || selectedClient;

  // Create the invite link with client query parameter preserved
  const inviteLink = clientId
    ? `/team/invite?${CLIENT_ID_PARAM}=${clientId}`
    : "/team/invite";

  return (
    <div className="flex items-center justify-between">
      <h1 className="text-2xl font-bold">Team</h1>
      <div className="flex gap-x-2">
        <Link to={inviteLink}>
          <ButtonPrimary text="Invite team member" icon={Add} />
        </Link>
      </div>
    </div>
  );
};

const Team = () => {
  const userRole = useContext(AdminContext);
  const isAdmin = userRole === "admin" || userRole === "platform-admin";

  return (
    <div className="flex flex-col flex-1 h-full px-12 gap-y-8">
      {/** Only show add team member button to admin and platform admin */}
      {isAdmin ? (
        <>
          <AddTeamMember />
          <TeamTable />
        </>
      ) : (
        <TeamTable />
      )}
    </div>
  );
};

export default Team;
